import {
  getObject,
  getList,
  getBoolean,
} from "@surya-digital/leo-ts-types";
import { QuestionViewResult, QuestionViewResultDTO, QuestionViewResultEnums } from "./questionViewResult";
import { SurveyStatusAndName, SurveyStatusAndNameDTO } from "../types/surveyStatusAndName";
import { SurveyViewName, SurveyViewNameDTO } from "./surveyViewName";


export namespace SurveyViewResultsEnums {
  export namespace QuestionData {
    export interface NoDataFoundDTO {
      case: string;
    }
    
    export class NoDataFound {
      readonly isQuestionDataNoDataFound: boolean = true;
    
    
    
    
    
      toDTO(): NoDataFoundDTO {
        const dto: NoDataFoundDTO = {
          case: "NO_DATA_FOUND",
        };
        return dto;
      }
      }
    
    NoDataFound.prototype.toString = function toString(): string {
      return `QuestionData.NO_DATA_FOUND()`;
    };
    
    export interface QuestionDataPresentDTO {
      case: string;
      questionViewResults: QuestionViewResultDTO[];
      isSurveyViewOptionDisplayTextSelected: boolean;
    }
    
    export class QuestionDataPresent {
      readonly isQuestionDataQuestionDataPresent: boolean = true;
    
      readonly questionViewResults: QuestionViewResult[];
      readonly isSurveyViewOptionDisplayTextSelected: boolean;
    
      static readonly constraints = {
        "questionViewResults": {
          "maxSize": 10,
        },
      }
    
      constructor(
      questionViewResults: QuestionViewResult[], 
      isSurveyViewOptionDisplayTextSelected: boolean
      ) {
        QuestionDataPresent.validateQuestionViewResults(questionViewResults);
        this.questionViewResults = questionViewResults;
        this.isSurveyViewOptionDisplayTextSelected = isSurveyViewOptionDisplayTextSelected;
      }
    
      static fromDTO(dto: QuestionDataPresentDTO): QuestionDataPresent {
        const questionViewResults = getList<QuestionViewResultDTO, QuestionViewResult>(
          dto,
          "questionViewResults",
          QuestionViewResult.fromDTO,
          InvalidSurveyViewResultsQuestionDataQuestionDataPresentQuestionViewResultsError
        );
        const isSurveyViewOptionDisplayTextSelected = getBoolean(dto, "isSurveyViewOptionDisplayTextSelected", InvalidSurveyViewResultsQuestionDataQuestionDataPresentIsSurveyViewOptionDisplayTextSelectedError);
        return new QuestionDataPresent(
          questionViewResults,
          isSurveyViewOptionDisplayTextSelected
        );
      }
    
      toDTO(): QuestionDataPresentDTO {
        const dto: QuestionDataPresentDTO = {
          case: "QUESTION_DATA_PRESENT",
            questionViewResults: this.questionViewResults.map((e: QuestionViewResult) => { return e.toDTO() }),
            isSurveyViewOptionDisplayTextSelected: this.isSurveyViewOptionDisplayTextSelected
        };
        return dto;
      }
      private static validateQuestionViewResults = (questionViewResults: QuestionViewResult[]): void => {
        if(questionViewResults.length > 10) {
          throw new InvalidSurveyViewResultsQuestionDataQuestionDataPresentQuestionViewResultsMaxSizeError(
            10,
            `Attribute questionViewResults is too long. Size is ${questionViewResults.length}. Max size is 10.`
          );
        }
      }
      
    }
    
    QuestionDataPresent.prototype.toString = function toString(): string {
      return `QuestionData.QUESTION_DATA_PRESENT(questionViewResults='${this.questionViewResults}',isSurveyViewOptionDisplayTextSelected='${this.isSurveyViewOptionDisplayTextSelected}')`;
    };
    
  
    export type QuestionData = NoDataFound | QuestionDataPresent;
  
    export type QuestionDataDTO = NoDataFoundDTO | QuestionDataPresentDTO;
  
    export const fromDTO = (dto: QuestionDataDTO): QuestionData => {
      switch (dto.case) {
        case "NO_DATA_FOUND":
            return new NoDataFound();
        case "QUESTION_DATA_PRESENT":
            return QuestionDataPresent.fromDTO(dto as QuestionDataPresentDTO);
        default:
          throw new InvalidSurveyViewResultsQuestionDataError(
              `Case ${dto.case} is not valid case of QuestionData.`
          );
      }
    };
  }
  
}
export interface SurveyViewResultsDTO {
  questionData: SurveyViewResultsEnums.QuestionData.QuestionDataDTO;
  surveyStatusAndName: SurveyStatusAndNameDTO;
  surveyViewName: SurveyViewNameDTO;
}

export class SurveyViewResults {
  readonly isSurveyViewResultsSurveyViewResults: boolean = true;

  readonly questionData: SurveyViewResultsEnums.QuestionData.QuestionData;
  readonly surveyStatusAndName: SurveyStatusAndName;
  readonly surveyViewName: SurveyViewName;


  constructor(
  questionData: SurveyViewResultsEnums.QuestionData.QuestionData, 
  surveyStatusAndName: SurveyStatusAndName, 
  surveyViewName: SurveyViewName
  ) {
    this.questionData = questionData;
    this.surveyStatusAndName = surveyStatusAndName;
    this.surveyViewName = surveyViewName;
  }

  static fromDTO(dto: SurveyViewResultsDTO): SurveyViewResults {
    const questionData = SurveyViewResultsEnums.QuestionData.fromDTO(getObject(dto, "questionData", InvalidSurveyViewResultsQuestionDataError));
    const surveyStatusAndName = SurveyStatusAndName.fromDTO(getObject(dto, "surveyStatusAndName", InvalidSurveyViewResultsSurveyStatusAndNameError));
    const surveyViewName = SurveyViewName.fromDTO(getObject(dto, "surveyViewName", InvalidSurveyViewResultsSurveyViewNameError));
    return new SurveyViewResults(
      questionData,
      surveyStatusAndName,
      surveyViewName
    );
  }

  toDTO(): SurveyViewResultsDTO {
    const dto: SurveyViewResultsDTO = {
        questionData: this.questionData.toDTO(),
        surveyStatusAndName: this.surveyStatusAndName.toDTO(),
        surveyViewName: this.surveyViewName.toDTO()
    };
    return dto;
  }
  }

SurveyViewResults.prototype.toString = function toString(): string {
  return `SurveyViewResults(questionData='${this.questionData}',surveyStatusAndName='${this.surveyStatusAndName}',surveyViewName='${this.surveyViewName}')`;
};

export class InvalidSurveyViewResultsError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyViewResultsError";
  }
}
export class InvalidSurveyViewResultsQuestionDataError extends InvalidSurveyViewResultsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyViewResultsQuestionDataError";
  }
}

export class InvalidSurveyViewResultsQuestionDataNoDataFoundError extends InvalidSurveyViewResultsQuestionDataError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyViewResultsQuestionDataNoDataFoundError";
  }
}

export class InvalidSurveyViewResultsQuestionDataQuestionDataPresentError extends InvalidSurveyViewResultsQuestionDataError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyViewResultsQuestionDataQuestionDataPresentError";
  }
}

export class InvalidSurveyViewResultsQuestionDataQuestionDataPresentQuestionViewResultsError extends InvalidSurveyViewResultsQuestionDataQuestionDataPresentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyViewResultsQuestionDataQuestionDataPresentQuestionViewResultsError";
  }
}

export class InvalidSurveyViewResultsQuestionDataQuestionDataPresentQuestionViewResultsMaxSizeError extends InvalidSurveyViewResultsQuestionDataQuestionDataPresentQuestionViewResultsError {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyViewResultsQuestionDataQuestionDataPresentQuestionViewResultsMaxSizeError";
  }
}

export class InvalidSurveyViewResultsQuestionDataQuestionDataPresentIsSurveyViewOptionDisplayTextSelectedError extends InvalidSurveyViewResultsQuestionDataQuestionDataPresentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyViewResultsQuestionDataQuestionDataPresentIsSurveyViewOptionDisplayTextSelectedError";
  }
}

export class InvalidSurveyViewResultsSurveyStatusAndNameError extends InvalidSurveyViewResultsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyViewResultsSurveyStatusAndNameError";
  }
}

export class InvalidSurveyViewResultsSurveyViewNameError extends InvalidSurveyViewResultsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyViewResultsSurveyViewNameError";
  }
}
